module.exports = __webpack_public_path__ + "img/xiaohongshu.d1d8ead6.png";